/**
 * Loading Component
 * Displays loading spinner for route transitions
 */

import React from 'react';
import { Icon } from '../../ui/Icon/Icon';
import { InterfaceIcons } from '../../ui/Icon/generalIcons';
import styles from './Loading.module.css';

export interface LoadingProps {
  /** Size of the loading spinner */
  size?: 'sm' | 'md' | 'lg';
  /** Optional loading message */
  message?: string;
  /** Full page loading (centered on screen) */
  fullPage?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  size = 'md',
  message,
  fullPage = false,
}) => {
  const content = (
    <div className={styles.loading__content}>
      <div className={styles[`loading__spinner--${size}`]}>
        <Icon icon={InterfaceIcons.Loading} size={size} />
      </div>
      {message && (
        <p className={styles.loading__message}>{message}</p>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className={styles.loading__fullPage}>
        {content}
      </div>
    );
  }

  return content;
};
